var _a;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var zeroState = {
    label: 'zero-state',
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: "".concat(48, "px ").concat(32, "px"),
    maxWidth: 460,
    textAlign: 'center',
    backgroundColor: '#ffffff',
};
export var image = {
    label: 'image',
    maxHeight: 100,
};
export var message = (_a = {
        label: 'message',
        margin: "".concat(32, "px auto"),
        color: '#323E48',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '125%',
        maxWidth: '35ch'
    },
    _a["@media ".concat(mobile(700))] = {
        label: 'media',
        margin: "".concat(16, "px auto"),
    },
    _a);
export var buttonContainer = {
    label: 'button-container',
};
